<template>
    <div ref="zhuzhuang" class="zhuzhuang"></div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  
  export default {
    name: "SanRankingZhuZhuang",
    data() {
      return{
        data:{},
        option : {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                type: 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            legend: {
                data:['销量']
            },
            xAxis: [
                {
                type: 'category',
                data: ['消费帮扶', '风电光伏帮扶', '订单农业帮扶', '扶贫大棚', '扶贫超市'],
                axisTick: {
                    alignWithLabel: true
                }
                }
            ],
            yAxis: [
                {
                type: 'value'
                }
            ],
            series: [
                {
                name: '销量',
                type: 'bar',
                barWidth: '60%',
                data: [300000, 100000, 50000, 102, 260, 330, 220]
                }
            ]
        }
      }
    },
    methods: {
      init() {
        this.myChart = echarts.init(this.$refs.zhuzhuang);
        this.myChart.setOption(this.option);
      },
    },
    mounted() {
      let user_id = window.localStorage.getItem('user_id');
  
      const data = {
        'user_id': user_id
      };
  
  
        this.option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                type: 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            legend: {
                data:['销量（元）']
            },
            xAxis: [
                {
                type: 'category',
                data: ['消费帮扶', '风电光伏帮扶', '订单农业帮扶', '扶贫大棚', '扶贫超市'],
                axisTick: {
                    alignWithLabel: true
                }
                }
            ],
            yAxis: [
                {
                type: 'value'
                }
            ],
            series: [
                {
                name: '销量（元）',
                type: 'bar',
                barWidth: '60%',
                data: [300000, 100000, 50000, 102, 260, 330, 220]
                }
            ]
        }
        this.myChart = echarts.init(this.$refs.zhuzhuang);
        this.myChart.setOption(this.option);
   
  



    },
    watch: {
      data(value) {
        this.option.data = value;
        this.myChart.setOption(this.option);
      },
    }
  }
  </script>
  
  <style scoped>
   .zhuzhuang{
     height: 100%;
     width: 100%;
   }
  </style>